<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 13 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.25 6V19.4167C11.25 21.995 9.16167 24.0833 6.58334 24.0833C4.00501 24.0833 1.91667 21.995 1.91667 19.4167V4.83333C1.91667 3.22333 3.22334 1.91667 4.83334 1.91667C6.44334 1.91667 7.75001 3.22333 7.75001 4.83333V17.0833C7.75001 17.725 7.22501 18.25 6.58334 18.25C5.94167 18.25 5.41667 17.725 5.41667 17.0833V6H3.66667V17.0833C3.66667 18.6933 4.97334 20 6.58334 20C8.19334 20 9.50001 18.6933 9.50001 17.0833V4.83333C9.50001 2.255 7.41167 0.166667 4.83334 0.166667C2.25501 0.166667 0.166672 2.255 0.166672 4.83333V19.4167C0.166672 22.9633 3.03667 25.8333 6.58334 25.8333C10.13 25.8333 13 22.9633 13 19.4167V6H11.25Z"
      :fill="fill"
    />
  </svg>
</template>

<script>
export default {
  name: 'IconAttachment',
  props: {
    width: {
      type: Number,
      default: 20,
    },
    height: {
      type: Number,
      default: 20,
    },
    fill: {
      type: String,
      default: '#495057',
    },
  },
};
</script>

<style scoped>
</style>